import React, { FC } from 'react';
import { getLanguage } from '~/utils/language';
import { useTranslation } from 'react-i18next';
import logoFr from '../assets/fr/logoFr.png';
import logoEn from '../assets/en/logoEn.png';
import {
  StyledRectangle, StyledCliplogo, StyledFondsCanadien, StyledIIROCAdvisor, StyledInnercontainer,
  StyledLigne, StyledContainer, StyledLegalNoticeParagraph,
} from './FooterWithLogo.styles';

interface FooterWithLogoProps {
  copyrightText: string;
}

const FooterWithLogo: FC<FooterWithLogoProps> = ({ copyrightText }) => {
  const { t } = useTranslation('App');
  let logocrcvm = logoFr;

  if (getLanguage() === 'en') {
    logocrcvm = logoEn;
  }

  return (
    <>
      <StyledLegalNoticeParagraph id="test">{copyrightText}</StyledLegalNoticeParagraph>
      <StyledRectangle>
        <StyledContainer>
          <StyledFondsCanadien href={t('hrefMemberOfCanadian')} target="_blank" data-testid="MemberOfCanadian">
            {t('memberOfCanadian')}
          </StyledFondsCanadien>
          <StyledLigne />
          <StyledInnercontainer>
            <a rel="noopener noreferrer" href={t('hrefLogoOcrcvm')} target="_blank" data-testid="hreflogocrcvm">
              <StyledCliplogo alt={t('altLogoOcrcvm')} src={logocrcvm} style={{ width: t('cssFooterLogoWidth') }} />
            </a>
            <StyledIIROCAdvisor id="StyledIIROCAdvisor" href={t('hrefOcrcvm')} target="_blank" data-testid="Ocrcvm" style={{ margin: t('cssFooterLogoMargin') }}>
              {t('ocrcvm')}
            </StyledIIROCAdvisor>
          </StyledInnercontainer>
        </StyledContainer>
      </StyledRectangle>
    </>
  );
};

export default FooterWithLogo;
